import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from '~/redux';
import Sticky from 'react-stickynode';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import content from '~/utils/contentAPI';
import config from '~/config';
import _ from 'lodash';

import { actions } from '~/redux/reducers';

import { breakpoints, calcRem, colors, css, fluidRange, respondFrom, styled, transitionDefault } from '~/styles';
import ResourceItem from './ResourceItem';
import ResourcesFilters from './ResourcesFilters';
import ResourcesViewModeSelector from './ResourcesViewModeSelector';
// import content from '*.jpg';


const StyledTopContainer = styled.div`
  color: ${colors.white};
  text-align: left;
  /* ${fluidRange('padding', '20px', '30px', breakpoints.xs, breakpoints.xl)} */
  padding: ${calcRem(30)};
  padding-bottom: 0 !important;
  z-index: 3;

  ${transitionDefault};
  transition-property: background-color, box-shadow;

  &.sticky {
    background: #4A4A4A;
    box-shadow: 0px 10px 15px -10px rgba(0, 0, 0, 0.7);
  }

  /* tmp */
  button {
    margin-right: 1em;
    margin-bottom: 1em;
  }
  ul {
    margin-bottom: 0.5rem;
  }
`

const PanelButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`

const StyledResultsAmount = styled.div`
  line-height: 1;
  padding-bottom: 1em;

  ${fluidRange('fontSize', '10px', '16px', breakpoints.xs, breakpoints.lg)}
`

const ResourcesListParent = styled.div`
  font-size: 21.5px;
  background: rgba(0, 0, 0, 0.7);
`

const StyledResourcesContainer = styled.div`
  /* ${fluidRange('padding', '20px', '30px', breakpoints.xs, breakpoints.xl)} */
  padding: ${calcRem(30)};
  padding-top: 0 !important;
`

const StyledResources = styled.ul`
  ${respondFrom(breakpoints.md, css`
    &.mode-grid {
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
        /* items right margin - last item compensation */
      ${fluidRange('marginRight', '-15px', '-30px', breakpoints.xs, breakpoints.lg)}

      &:after {   // fill the space in the last line!
        content: '';
        flex: auto;
      }
    }
  `)};
`

const StatusText = styled.p`
  color: ${colors.white};
  padding-bottom: 1em;
`

export const ResourcesList = () => {
  // redux state
  const user = useSelector((state) => state.user);
  const resources = useSelector((state) => state.resources);
  const dispatch = useDispatch();
  const query = queryString.parse(useLocation().search);

  // local state
  const [statusText, setStatusText] = useState('');
  const [allFilters, setAllFilters] = useState<any[]>([]);
  const [gridModeSelected, setGridModeSelected] = useState(false);  // TODO: store?

  // load resources data when user changes
  useEffect(() => {
    async function fetchData() {
      if (config.debug) { console.log('loading resources'); }

      if (user !== null) {  
        // const res = await strapi.get(
        //   '/resources',
        //   config.features.userAuthentication ? authHeader(user.token) : {}
        // );

        const resourcesData = await content.loadResources() as any[];
        
        // order ascending by title
        const orderedResources = _.orderBy(resourcesData, ['title'], ['asc']);

        dispatch({
          type: actions.UPDATE_RESOURCES,
          payload: orderedResources,
        });

        // assemble list of filters -- that is, get list of unique resource types
        const _allFilters: any[] = [];
        resourcesData.forEach((resource) => {
          _allFilters.push(resource.type);
        });
        setAllFilters([...new Set(_allFilters)]);

        if (config.debug) { console.log('updated all filters list', allFilters); }

        setStatusText('');
      } else {
        setStatusText('Loading...');
      }
    }
    fetchData().catch((error) => {
      if (config.debug) { console.log('error loading resources', error); }
      setStatusText('Error loading resources. Try reloading the page.');
    });

  // }, [allFilters, dispatch, user]);
  }, [user]);

  const filterActive = useCallback( filter => {
    return (
      !!query.filters &&
      typeof query.filters === 'string' &&
      query.filters.split(',').indexOf(filter) > -1
    );
  }, [query.filters]);

  const activeResources = useMemo(
    () => resources.all.filter( res =>  
      !query.filters || 
      filterActive(res.type) ||
      // ( query.filters.includes('Favorites') && resources.favoriteResources.includes(res.id) )
      ( query.filters.includes('Favorites') && _.find(user?.favoriteResources, ['id', res.id]) )
    )
  , [filterActive, query.filters, resources])

  const mode = gridModeSelected ? 'grid' : 'list';
  

  return (
    <ResourcesListParent>
      <Sticky top='#header-container' innerZ={3} >
        { 
          sticky => (
            <StyledTopContainer className={`
              ${sticky.status === Sticky.STATUS_FIXED ? 'sticky' : ''}
            `}>
              <PanelButtonsContainer>
                <ResourcesFilters {...{allFilters}} />
                <ResourcesViewModeSelector 
                  gridModeSelected={gridModeSelected}
                  onGridModeSelected={setGridModeSelected} />
              </PanelButtonsContainer>

              <StyledResultsAmount>
                Showing {activeResources.length} result{activeResources.length !== 1 ? 's' : ''}
              </StyledResultsAmount>
            </StyledTopContainer>
          )
        }
      </Sticky>

      <StyledResourcesContainer>
        <StyledResources className={`mode-${mode}`}>
          {activeResources.map((resource, index) => 
            // TODO: wrap this with AnimatePrecence (framer-motion) to animate
            <ResourceItem key={index} {...{ resource, index, mode }} />
          )}
        </StyledResources>
      </StyledResourcesContainer>

      { !!statusText && <StatusText>{statusText}</StatusText> }
    </ResourcesListParent>
  );
}

export default ResourcesList;


// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourcesList.tsx